import React, { useState, useEffect } from 'react';
import {NeuroMessage} from "@ignitesales/neuro-application";
import classnames from "classnames";
import { ActionService } from '@ignitesales/neuro-application/src/neuro-guide/services/ActionService.mjs';
import ActionButton from './ActionButton';

// position is defined within ThemeManifest
// page must be one of these: LandingPage, SummaryPage, SurveyPage
const ActionButtonContainer = ({ className, position, page }) => {
    const componentClass = "action-button-container";
    const classes = classnames('button', componentClass, className);
    const [ actions, setActions ] = useState([]);

    useEffect(() => {
        const fetchActions = async () => {
            try {
                const actionsData = await ActionService.getActionByPosition(page, position);
                setActions(Array.isArray(actionsData) ? actionsData : []);
            } catch (e) {
                console.log('Action Button Container error', e);
            }
        };

        fetchActions();
    }, [page, position]);

    return (
        <div className={classes}>
            {actions.map((action, index) => (
                <ActionButton position={position} key={index} action={action} />
            ))}
        </div>
    );
};

export default ActionButtonContainer;
